import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M640.376471,734.117647 C762.352941,734.117647 762.352941,847.058824 885.458824,847.058824 C944.396047,847.058824 974.820774,820.557944 1004.36389,793.262914 L1006.37715,791.40096 C1009.73139,788.296659 1013.08235,785.189647 1016.47059,782.117647 L1016.47059,847.058824 C1016.47059,1002.80471 889.863529,1129.41176 734.117647,1129.41176 C578.371765,1129.41176 451.764706,1002.80471 451.764706,847.058824 L451.764706,835.764706 C477.255529,825.401224 496.005075,808.791236 514.580831,791.975917 L517.59263,789.248263 C548.218187,761.518216 579.336282,734.117647 640.376471,734.117647 Z M1920,-0.0112941176 L1920,1129.40047 L1581.17647,1129.40047 L1581.17647,1016.45929 L1807.05882,1016.45929 L1807.05882,112.929882 L112.941176,112.929882 L112.941176,1016.45929 L225.882353,1016.45929 L225.882353,1129.40047 L0,1129.40047 L0,-0.0112941176 L1920,-0.0112941176 Z M1471.84941,714.24 L1115.52,1663.17176 C941.251765,1673.56235 666.578824,1681.12941 484.517647,1615.05882 L522.917647,1508.89412 C653.251765,1556.32941 860.724706,1562.76706 1052.72471,1550.56941 L1185.31765,1195.93412 L1124.89412,1180.12235 C1078.13647,1167.92471 1031.04,1158.77647 983.717647,1150.98353 C1071.92471,1078.47529 1129.41176,969.938824 1129.41176,847.058824 L1129.41176,734.117647 C1129.41176,516.141176 952.094118,338.823529 734.117647,338.823529 C516.141176,338.823529 338.823529,516.141176 338.823529,734.117647 L338.823529,847.058824 C338.823529,969.712941 396.197647,1078.13647 484.065882,1150.64471 C428.047059,1160.01882 372.592941,1171.53882 318.042353,1187.12471 C197.308235,1221.45882 112.941176,1333.49647 112.941176,1459.2 L112.941176,1788.31059 L147.84,1802.76706 C332.272941,1879.45412 535.115294,1920 734.117647,1920 C914.371765,1920 1082.76706,1904.07529 1208.24471,1875.27529 C1258.61647,1863.86824 1299.16235,1828.29176 1316.89412,1780.17882 L1348.74353,1692.87529 C1363.08706,1653.68471 1356.31059,1610.88 1330.33412,1578.35294 C1317.34588,1561.86353 1300.51765,1549.44 1281.76941,1541.87294 L1577.56235,753.995294 L1471.84941,714.24 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEducatorsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconEducatorsSolid, _Component);

  var _super = _createSuper(IconEducatorsSolid);

  function IconEducatorsSolid() {
    _classCallCheck(this, IconEducatorsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconEducatorsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEducators",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEducatorsSolid.displayName = "IconEducatorsSolid";
  return IconEducatorsSolid;
}(Component);

IconEducatorsSolid.glyphName = 'educators';
IconEducatorsSolid.variant = 'Solid';
IconEducatorsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEducatorsSolid;
export { IconEducatorsSolid };